import { apiEventsFetch } from '..';
import { GetEventsAccessRes } from './types';

/**
 * The call layer over `/events/v1/gamma/events-access` — who may manage their own events.
 *
 * Served by the events context, not the user context: every grant these routes make is an events
 * permission. Separate from `gammaRolesClient` because the backend deliberately keeps them apart —
 * these are pinned to one permission and open to Gamma admins, while the role API takes any
 * permission and is GammaSuperAdmin-only.
 */
export interface EventsAccessClient {
  getEventsAccess: () => Promise<GetEventsAccessRes>;
  setPersonAccess: (_userId: string, _granted: boolean) => Promise<void>;
}

export const eventsAccessClient: EventsAccessClient = {
  getEventsAccess: () => apiEventsFetch<GetEventsAccessRes>('/gamma/events-access'),

  setPersonAccess: (userId, granted) =>
    apiEventsFetch<void>(`/gamma/events-access/users/${userId}`, {
      method: granted ? 'PUT' : 'DELETE',
    }),
};
